import wixLocation from 'wix-location';
import wixWindow from 'wix-window';

const createHtml = (text, url, extraStyle) => `<h2 style="font-size:15px"><span style="font-size:15px"><span style="font-family:wfont_311dce_37a69b3a7ca14f258c3442f95b081dd3,wf_37a69b3a7ca14f258c3442f95,orig_helvetica_neue_w_01_55_roman;border-bottom-width: 1px;border-bottom-style: solid;padding-bottom: 3px;${extraStyle}"><a href="${url}" target="_self">${text}</span></span></a></h2>`;
const regularHtml = (text, url) => createHtml(text, url, '');
const hoverHtml = (text, url) => createHtml(text, url, 'color: #0067ff;');

$w.onReady(function () {

	let formFactor = wixWindow.formFactor;
	if (formFactor !== "Mobile") {
		$w('#slideshow2').hide();
		$w('#group1').hide();
	}

	$w('#pressRepeater').onItemReady(($item, itemData, index) => {
		$item("#text46").text = textShortening(itemData)
		const text1 = $item('#pressBtnLabel');
		text1.html = regularHtml(text1.text,itemData.url );

		// $item('#pressItemBtn').onClick(() => {
		// 	wixLocation.to(itemData.url)
		// })

		$item('#pressItemBtn').onMouseIn(() => {
			text1.html = hoverHtml(text1.text, itemData.url);
		});

		$item('#pressItemBtn').onMouseOut(() => {
			text1.html = regularHtml(text1.text, itemData.url);
		});

	});

	$w('#newsRepeater').onItemReady(($item, itemData, index) => {
		$item("#text51").text = textShortening(itemData)
		const text2 = $item('#newsBtnLabel');
		text2.html = regularHtml(text2.text, itemData.url);

		$item('#newsItemBtn').onClick(() => {
			$w('#html1').postMessage(itemData.url)
		})

		$item('#newsItemBtn').onMouseIn(() => {
			text2.html = hoverHtml(text2.text, itemData.url);
		});

		$item('#newsItemBtn').onMouseOut(() => {
			text2.html = regularHtml(text2.text, itemData.url);
		});
	});

});

export function viewAllNews_click(event) {
	wixLocation.to("/news")
}

export function viewAllPressReleases_click(event) {
	wixLocation.to("/press-releases")
}

function textShortening(itemData) {
	let fullText = itemData.title;
	let text2Show
	if (fullText.length >= 85) {
		text2Show = fullText.slice(0, 85) + "..."
		return text2Show;
	}
	return fullText;
}
